'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (node) {
	return {
		type: 'POPUP',
		name: 'Popup',
		allowedSections: ['header', 'footer', 'main'],
		disallowedChildren: [],
		category: 'Nav',
		props: [{
			name: 'cookieControlled',
			inputType: 'checkbox',
			label: 'Controlled by cookie',
			default: false
		}, node && node.props.cookieControlled && {
			name: 'cookieMaxAge',
			inputType: 'text',
			label: 'Cookie expires after X days',
			default: ''
		}, node && node.props.cookieControlled && {
			name: 'cookieName',
			inputType: 'text',
			label: 'Cookie name',
			default: ''
		}, node && !node.props.cookieControlled && {
			name: 'iconClosed',
			inputType: 'icon',
			label: 'Choose icon when popoup is closed',
			default: false
		}, node && !node.props.cookieControlled && {
			name: 'iconClosedSize',
			inputType: 'text',
			label: 'Set size on above icon',
			default: '2em'
		}, node && !node.props.cookieControlled && {
			name: 'iconOpen',
			inputType: 'icon',
			label: 'Choose icon when popup is open',
			default: false
		}, node && !node.props.cookieControlled && {
			name: 'iconOpenSize',
			inputType: 'text',
			label: 'Set size on above icon',
			default: '2em'
		}, node && !node.props.cookieControlled && {
			name: 'label',
			inputType: 'text',
			label: 'Button text',
			default: 'Click me'
		}, {
			name: 'iconPopupClose',
			inputType: 'icon',
			label: 'Choose popup close icon',
			default: false
		}, {
			name: 'iconPopupCloseSize',
			inputType: 'text',
			label: 'Set size on above icon',
			default: '2em'
		}, {
			name: 'popupCloseText',
			inputType: 'text',
			label: 'Popup close text',
			default: 'Close'
		}, {
			name: 'height',
			inputType: 'text',
			label: 'Popup height',
			default: '250px',
			required: true
		}, {
			name: 'width',
			inputType: 'text',
			label: 'Popup width',
			default: '480px',
			required: true
		}].filter(Boolean),
		hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
			label: 'Advanced settings',
			props: [{
				name: 'openByDefault',
				inputType: 'checkbox',
				label: 'Open by default',
				default: false
			}, {
				name: 'identifier',
				inputType: 'text',
				label: 'Popup identifier',
				default: ''
			}, {
				name: 'keepOpen',
				inputType: 'checkbox',
				label: 'Keep open',
				default: false
			}, {
				name: 'closeOnUrlChange',
				inputType: 'checkbox',
				label: 'Close popup on URL change',
				default: true
			}, {
				name: 'onAction',
				inputType: 'select',
				label: 'On Action',
				values: [{
					label: 'None',
					value: 'NONE'
				}, {
					label: 'Shopcart add',
					value: 'SHOPCART_ADD_FULFILLED'
				}, {
					label: 'Favorite add',
					value: 'ARTICLES_FAVORITES_ADD_FULFILLED'
				}, {
					label: 'Leave window remarketing',
					value: 'LEAVE_WINDOW_REMARKET'
				}],
				default: 'NONE'
			}, {
				name: 'onActionAction',
				label: 'Action',
				inputType: 'select',
				values: [{
					label: 'Open',
					value: 'OPEN'
				}, {
					label: 'Close',
					value: 'CLOSE'
				}],
				default: 'OPEN'
			}, {
				name: 'actionDuration',
				inputType: 'text',
				label: 'Auto ' + (node && node.props.onActionAction === 'OPEN' ? 'close' : 'open') + ' after ' + (node && node.props.actionDuration) + 'ms (0 = infinite)', default: '3000'
			}]
		})
	};
};